import DataCatalog from 'components/data-catalogs/DataCatalogs.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import fs from "fs";
import React from "react";

export default function DataCatalogsPage({blogs,casestudies}){
  return(
    <DataCatalog blogs={blogs} casestudies={casestudies}  />
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });

  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);
  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);

  return {
    props: {
      meta: {
        title: "Data Catalogs",
        description: "Tired of manually sending files round the office? Tell Simon he can find the document he’s looking for in your new data catalog.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      blogs: blogsList,
      casestudies: caseStudiesList,
    },
  };
};